module.exports = __webpack_public_path__ + "img/ge.348bbf00.svg";